// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const handelNameKey = (name: any) => {
  return typeof name === 'string' ? name : name?.original;
};
